import { FilterMapping } from "../features/searchpage/constants/filters.constants";
import { environments } from "../constants/constants"
import { AppRouteURL } from "../routes/app-route-urls";
import { LocalStorageDataModel } from "../constants/local-storage-data-model";
import { postData } from "../services/global.service";
import { API_CONSTANTS } from "../constants/search.constanst";
import CryptoJS from "crypto-js";
import { APIEnv, APIStatus } from "../interface/baseInterfaces";
import { osName, osVersion, browserName, browserVersion } from 'react-device-detect';


export function Env() {
  return environments[env()]
}

function env() {
  const hostname = window.location.hostname;

  const developmentHosts = ['localhost', 'dev','stag'];
  const uatHosts = ['uat'];
  const stagingHosts = ['preprod', 'stag'];

  if (developmentHosts.some(host => hostname.includes(host))) {
    return 'development';
  }else if (uatHosts.some(host => hostname.includes(host))) {
    return 'uat';
  } else if (stagingHosts.some(host => hostname.includes(host))) {
    return 'staging';
  } else {
    return 'production';
  }
}

export const getFilterKeyByApiKey = (apiKey: any) => {
    for (const key in FilterMapping) {
      if (FilterMapping[key].apiKey === apiKey) {
        return key;
      }
    }
    return ''; // Return null if no match is found
  };

  export const areParamsEqual = (params1: any, params2: any) => {
    // Implement your custom comparison logic here
    // For a simple shallow comparison, you can use JSON.stringify
    return JSON.stringify(params1) === JSON.stringify(params2);
  };

  export const checkArrayInArray =(arr:any, farr:any)=>{
    if(JSON.stringify(arr).includes(JSON.stringify(farr))) return true;
    return false;
};

export const createSlugByIdName = (inputString: string): string => {
  return inputString.toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').trim()
  
  }
  
  export const createSlugByIdNamePractice = (inputString: string): string => {
    return inputString.replace(/[^\w\s-]/g, '').replace(/\s+/g, '').replace(/-+/g, '').trim()
    }

    export const isPremiumSearchPage = (pagePath: string): boolean => {
      return pagePath?.includes(AppRouteURL.SEARCH);
    };

    export const setDataOnLocalStorage = (key: string, value: string) => {
      return localStorage.setItem(key, value);
    };
    
    export const setDataOnLocalStorageWithExpiry =(key:string, value:any, ttl:any) => {
      const now = new Date();
      const item = {
        value: value,
        expiry: now.getTime() + ttl,
        date: now.toLocaleDateString()
      }
      return localStorage.setItem(key, JSON.stringify(item))
    }
    
    export const getDataFromLocalStorage = (key: string) => {
      var value = localStorage.getItem(key);
      if (value === null) {
        return "";
      }
      return value;
    };
    
    export const removeDataFromLocalStorage = (key: string) => {
      localStorage.removeItem(key);
      return;
    };
    
    export const isMobile = () => {
      let mediaQueryObj = window.matchMedia("(max-width: 950px)");
      return mediaQueryObj.matches;
    };
    export const isTablet = () => {
      const width = window.innerWidth;
      return width > 600 && width <= 950;
    };
    
    export const isDesktop = () => {
      return window.innerWidth > 950;
    };

    export const checkIsUserLoggedIn = () => {
     return getDataFromLocalStorage("TaxmannAuthorization");
    }

    export const login = () => {
      const currentPath = window.location.pathname;
      setDataOnLocalStorage(LocalStorageDataModel.INTERNAL_REFRERRER_URL, currentPath);
        setDataOnLocalStorage(LocalStorageDataModel.PREVIOUS_URL, window.location.href);
    }

    export const createSlugByName = (inputString:string) => {
      return inputString.trim().replace(/[^a-z0-9,. ]/gi, '').replaceAll(' ', '-');
    }
    export interface IFooterLinkModel {
      name: string;
      url: string;
      externalLink?: boolean;
      sameTab?: boolean;
      queryParams?: any;
      isHtml?: boolean;
      isNew?: boolean;
    }

    export const decrypt = (ciphertext: string) => {
      let key = Env().REACT_APP_SCCRET_KEY_MACID;
      const secretKey = key.replace(/KEYGEN/g, btoa("KEYGEN"));
      var bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
      var originalText = bytes.toString(CryptoJS.enc.Utf8);
      return originalText;
    };

    export const getUserIpAddress = async () => {
      return await postData(
        API_CONSTANTS.USER_IP_ADDRESS,
        { domainname: location.hostname },
        APIEnv.NODE_DASHBOARD_SESSION_MANAGEMENT,
        "post"
      ).then((res: any) => {
        if (res?.ResponseType === APIStatus.SUCCESS) {
          setDataOnLocalStorage(LocalStorageDataModel.USER_IP, res?.data[0]);
          return res?.data[0];
        }
      });
    };
    export const postUserSiteTracking = async (body: any) => {
      try {
        const response = await postData(
          API_CONSTANTS.USER_SITE_TRACKING,
          body,
          APIEnv.REDIS,
          "post"
        );
        
        return response;
      } catch (error) {
        console.error("Error in postUserSiteTracking:", error);
        return null;
      }
    };

    export const getMachineId = async () => {
      if (getDataFromLocalStorage(LocalStorageDataModel.MACHINE_ID_NEW)) {
        return Promise.resolve(true);
      } else {
        removeDataFromLocalStorage(LocalStorageDataModel.MACHINE_ID);
        return await postData(
          API_CONSTANTS.GET_MACHINE_ID,
          {},
          APIEnv.REDIS,
          "get"
        ).then((res: any) => {
          if (res?.ResponseType === APIStatus.SUCCESS) {
            if (res?.Data) {
              let decryptedID: any = decrypt(res?.Data);
              if (decryptedID) {
                decryptedID = JSON.parse(decryptedID);
                if (decryptedID && decryptedID.machineId) {
                  setDataOnLocalStorage(
                    LocalStorageDataModel.MACHINE_ID_NEW,
                    decryptedID.machineId
                  );
                  // kept old machine id too , as it can affect the otther apps like bookstore and students
                  setDataOnLocalStorage(
                    LocalStorageDataModel.MACHINE_ID,
                    decryptedID.machineId
                  );
                  return Promise.resolve(true);
                } else {
                  return Promise.resolve(false);
                }
              } else {
                return Promise.resolve(false);
              }
            }
          }
        });
      }
    };
    export const redirectToReactCart = async () => {
      window.open('/gp/checkout/information', "_self")
    }

    export const redirectToReactLogin = async () => {
      window.open('/gp/auth/login', "_self")
    }

    export const initializeCheckoutData = async () => {      
      let checkoutData: any = {
        checkoutCart: "",
        cartSource: "C",
        billingId: "",
        shippingId: "",
        type: ''
      };
      setDataOnLocalStorage("checkoutData", JSON.stringify(checkoutData));
    }

    export const pushUtmSourceInformation = (
      description: string,
      deleteCampaignAfterPush: boolean = false,
      recordType = "GENERAL",
      data: any = {},
      actionType = "GENERAL"
    ): void => {
      let campaignName = getDataFromLocalStorage("activeCampaign");
      const { pathname, search } = window.location;
      if (!campaignName) {
        return;
      }
      let userIp = getDataFromLocalStorage(LocalStorageDataModel.USER_IP);
      let campaignUrl = getDataFromLocalStorage("activeCampaignUrl");
      let payload = {
        IpAddress: userIp,
        Action: description,
        CampaignName: campaignName,
        UtmDetails: JSON.parse(getDataFromLocalStorage(campaignName)),
        ComponentUrl: pathname + search,
        CampaignUrl: campaignUrl,
        platform: "taxmann",
        recordType: recordType, // GENERAL, CRM,
        actionType: actionType, // GENERAL, FREE_TRIAL, REQUEST_CALLBACK,
        data: data, // can be as per IUTMDataProps keys,
        UserEmail: getDataFromLocalStorage(LocalStorageDataModel.EMAIL),
        UserName: getDataFromLocalStorage(LocalStorageDataModel.USER_NAME),
      };
      let isLoggedIn = checkIsUserLoggedIn();
      let url = isLoggedIn
        ? "tracking/userActionTracking"
        : "tracking/userActionTracking?verifyToken=NO";
      // console.log("this is url: ", url);
      postData(url, payload, APIEnv.MARKETING)
        .then((res) => {
          // console.log("this is marketing postData: ", res);
          if (res && res.success == true) {
            if (deleteCampaignAfterPush) {
              removeDataFromLocalStorage("activeCampaign");
              removeDataFromLocalStorage(campaignName);
            }
          }
        })
        .catch((err) => { });
    };

    const deviceInfo = {
      os: osName || 'Unknown',
      osVersion: osVersion || 'Unknown',
      browser: browserName || 'Unknown',
      browserVersion: browserVersion || 'Unknown',
      userAgent: navigator.userAgent
    };

    export const DeviceDetect = () => {
      
      let deviceType = '';
      if (isDesktop()) deviceType = 'DESKTOP';
      else if (isTablet()) deviceType = 'TABLET';
      else if (isMobile()) deviceType = 'MOBILE';
    
      return {
        deviceType,
        device: isMobile() ? 'Mobile' : isTablet() ? 'Tablet' : 'Desktop',
        os: deviceInfo.os,
        os_version: deviceInfo.osVersion,
        browser: deviceInfo.browser,
        browser_version: deviceInfo.browserVersion,
        userAgent: deviceInfo.userAgent
      };
    };

    export const getUserSiteTrackingData = (fileId?: string , additionalData?:any) => {
      const { deviceType, device, os, os_version, browser, browser_version, userAgent } = DeviceDetect();
      const componentLocation = decodeURIComponent(window.location.href).replace(/'/g, "");
      let componentURL = componentLocation;

      if (fileId && additionalData && Object.keys(additionalData).length > 0) {
        componentURL = `${componentLocation}/${JSON.stringify(additionalData)}`;
      }
      return {
        ipAddress: getDataFromLocalStorage(LocalStorageDataModel.USER_IP) || "",
        userAgent: userAgent,
        device: device,
        os: os,
        osVersion: os_version,
        browser: browser,
        browserVersion: browser_version,
        deviceType: deviceType,
        componentURL: componentURL,
      };
    };
    export const sendUserDeviceTracking = async (fileId:any,additionalData = {}) => {
      try {
        let payload = { TrackingList: [], verifyToken: '' };
        let data = getUserSiteTrackingData(fileId, additionalData);
        payload.TrackingList = [data];

        const response = await postUserSiteTracking(payload);
        
        return response;
      } catch (error) {
        console.error("Error in sendUserDeviceTracking:", error);
        return null;
      }
    };

    export const searchLogData = async (obj: any, search: string) => {
      try {
        let cleanedSearchText = search.replace(/[`'\\]/gi, '');
        let searchKeyword = encodeURIComponent(cleanedSearchText);
        obj['searchKeyword'] = searchKeyword;
    
        if (!checkIsUserLoggedIn()) {
          obj['verifyToken'] = 'NO';
        }
    
        const response = await postData(
          API_CONSTANTS.SEARCH_LOG,
          obj,
          APIEnv.REDIS,
          'post'
        );
    
        return response;
      } catch (error) {
        console.error("Error in postSearchLogs:", error);
        return null;
      }
    };

export const getDataFromLocalStorageWithExpiry = (key: any) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};